"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_button_1 = require("@buoyhealth/common.buoy-button");
const common_buoy_dialog_1 = require("@buoyhealth/common.buoy-dialog");
const common_buoy_input_1 = require("@buoyhealth/common.buoy-input");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const styles_1 = require("@mui/material/styles");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const feedbackQuestions_1 = __importStar(require("./feedbackQuestions"));
const snowplowConfig_1 = require("../../common/snowplowConfig");
const TextFeedback_1 = __importDefault(require("../TextFeedback"));
const buttonStyles = (0, styled_components_1.css) `
  ${(props) => props.theme.typography.variants.primary.small};
  background-color: ${(props) => props.theme.palette.gray[0]};
  color: ${(props) => props.theme.palette.gray[70]};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding: 16px;
  justify-content: flex-start;

  &:hover {
    background-color: ${(props) => props.theme.palette.gray[10]};
  }

  &.Mui-focusVisible {
    box-shadow: ${(props) => `inset 0 0 10px 0 ${props.theme.palette.primary.main}, 0 0 5px 0 ${props.theme.palette.primary.main}}`};
  }
`;
const Paragraph = styled_components_1.default.p `
  ${(props) => props.theme.typography.variants.primary.main};
  margin: 0 0 16px;
`;
const QuestionContainer = styled_components_1.default.div `
  margin-bottom: 32px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;
/** Button and dialog for collecting user feedback on care resource cards */
const ResourceUserFeedback = ({ careResource }) => {
    const r = (0, common_buoy_theme_1.useResponsive)();
    const theme = (0, styles_1.useTheme)();
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const [answerValue, setAnswerValue] = (0, react_1.useState)();
    const [freeTextValue, setFreeTextValue] = (0, react_1.useState)();
    const [hasError, setHasError] = (0, react_1.useState)(false);
    const [modalPhase, setModalPhase] = (0, react_1.useState)(feedbackQuestions_1.ModalPhase.Start);
    const firstQuestionRef = (0, react_1.useRef)(null);
    /** Resource context; sent to snowplow */
    const careResourceContext = (0, react_1.useMemo)(() => ({
        schema: snowplowConfig_1.SnowplowContextSchema.CareResource,
        data: {
            name: careResource.name,
            careCollectionResourceToken: careResource.care_collection_resource_token,
        },
    }), [careResource.care_collection_resource_token, careResource.name]);
    const resetForm = () => {
        setAnswerValue(undefined);
        setFreeTextValue(undefined);
        setHasError(false);
    };
    const openModal = () => {
        (0, snowplowConfig_1.trackSnowplowEvent)(snowplowConfig_1.SnowplowEventSchema.ActionSchema, {
            action: snowplowConfig_1.SnowplowAction.GiveFeedbackClick,
        }, careResourceContext);
        setIsModalOpen(true);
    };
    const closeModal = (0, react_1.useCallback)(() => {
        resetForm();
        setModalPhase(feedbackQuestions_1.ModalPhase.Start);
        setIsModalOpen(false);
    }, []);
    const onModalClose = () => {
        (0, snowplowConfig_1.trackSnowplowEvent)(snowplowConfig_1.SnowplowEventSchema.ActionSchema, {
            action: snowplowConfig_1.SnowplowAction.SurveyDismissed,
        }, careResourceContext);
        closeModal();
    };
    const currentQuestion = feedbackQuestions_1.default[modalPhase];
    const handleSubmitClick = (0, react_1.useCallback)(() => {
        if (!answerValue || !answerValue.length) {
            firstQuestionRef.current?.parentElement?.scrollTo({
                behavior: "smooth",
                top: 0,
            });
            setHasError(true);
            return;
        }
        currentQuestion.questions.forEach((question) => {
            const answer = question.inputType === "text" ? freeTextValue : answerValue;
            (0, snowplowConfig_1.trackSnowplowEvent)(snowplowConfig_1.SnowplowEventSchema.QuestionSchema, {
                question: question.prompt || currentQuestion.subTitle,
                answer: (0, isArray_1.default)(answer) ? answer.join(", ") : answer,
            }, careResourceContext);
        });
        if (modalPhase === feedbackQuestions_1.ModalPhase.Start) {
            if (answerValue === feedbackQuestions_1.InitialPromptAnswer.Yes) {
                setModalPhase(feedbackQuestions_1.ModalPhase.Positive);
            }
            else {
                setModalPhase(feedbackQuestions_1.ModalPhase.Negative);
            }
        }
        else {
            setModalPhase(feedbackQuestions_1.ModalPhase.Start);
            closeModal();
        }
    }, [
        answerValue,
        careResourceContext,
        closeModal,
        currentQuestion.questions,
        currentQuestion.subTitle,
        freeTextValue,
        modalPhase,
    ]);
    const handleAnswerChange = (_e, value) => {
        setHasError(false);
        setAnswerValue(value);
    };
    const handleTextChange = (value) => {
        setFreeTextValue(value);
    };
    (0, react_1.useEffect)(() => {
        resetForm();
    }, [modalPhase]);
    const modalActions = (0, react_1.useMemo)(() => [
        {
            key: modalPhase,
            label: "Submit",
            onClick: handleSubmitClick,
            isPrimary: true,
        },
    ], [handleSubmitClick, modalPhase]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(common_buoy_button_1.BaseButton, { fullWidth: true, onClick: openModal, styles: buttonStyles, touchRippleColor: theme.palette.gray[20], children: "Give feedback" }), (0, jsx_runtime_1.jsx)(common_buoy_dialog_1.ResponsiveDialog, { actions: modalActions, "data-testid": "resource-user-feedback-dialog", maxWidth: r({ md: 460, lg: 548 }), onClose: onModalClose, open: isModalOpen, subTitle: currentQuestion.subTitle, title: currentQuestion.title, children: currentQuestion.questions.map((question, i) => ((0, jsx_runtime_1.jsxs)(QuestionContainer, { ref: i === 0 ? firstQuestionRef : null, children: [question.prompt && (0, jsx_runtime_1.jsx)(Paragraph, { children: question.prompt }), question.options && ((0, jsx_runtime_1.jsx)(common_buoy_input_1.ToggleButtonGroup, { "data-testid": "question-toggle-button-group", errorMessage: "Please select a response", hasError: hasError, multiSelect: question.inputType === "multiSelect", onChange: handleAnswerChange, options: question.options.map((option, j) => ({
                                "data-testid": `question-${j}`,
                                label: option,
                                value: option,
                            })), value: answerValue })), question.inputType === "text" && ((0, jsx_runtime_1.jsx)(TextFeedback_1.default, { disableAutoFocus: true, handleValueChange: handleTextChange }))] }, i.toString()))) })] }));
};
exports.default = ResourceUserFeedback;
//# sourceMappingURL=index.js.map